import { UserRole } from '@feedyou/schema'
import botPermissionsSchema from '@feedyou-ai/feedbot-schema/schema/botLevelPermissions.json'

export const rolesArray: Roles[] = [
  ...botPermissionsSchema.properties.tokens.items.properties.role.enum,
  'admin'
] as any

// 'admin' doesn't exist as an actual role in DB,
// but is instead injected by server in runtime
export type Roles = UserRole | 'admin'

export const PAID_ROLES = ['edit', 'admin']
